import { render } from "./FileViewer.vue?vue&type=template&id=bb8af982"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Radsystem\\asystem\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QAvatar,QBtn,QTooltip});
